import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Form } from "react-bootstrap";

interface DateRangeProps {
  onDateRangeChange: (startDate: Date | null, endDate: Date | null) => void;
}

const DateRange: React.FC<DateRangeProps> = ({ onDateRangeChange }) => {
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();
  const firstJan = new Date(currentYear, currentMonth, 1);
  const today = new Date();
  firstJan.setHours(today.getHours(), today.getMinutes(), today.getSeconds(), today.getMilliseconds());

  const [startDate, setStartDate] = useState<Date | null>(firstJan);
  const [endDate, setEndDate] = useState<Date | null>(today);

  useEffect(() => {
    onDateRangeChange(firstJan, today);
  }, []);

  const changeStartDate = (newStartDate: Date | null) => {
    if (!newStartDate) return;
    setStartDate(newStartDate);
    onDateRangeChange(newStartDate, endDate);
  };

  const changeEndDate = (newEndDate: Date | null) => {
    if (!newEndDate) return;
    setEndDate(newEndDate);
    onDateRangeChange(startDate, newEndDate);
  };

  return (
    <Form.Group controlId="daterange" className="my-2 w-100">
      <Form.Label className="fw-semibold">Date Range</Form.Label>
      <div className="date-picker d-flex align-items-center">
        <DatePicker
          selected={startDate}
          onChange={changeStartDate}
          selectsStart
          className="form-control form-control-md"
          startDate={startDate}
          endDate={endDate}
          placeholderText="Select start date"
        />
        <span className="mx-2">-</span>
        <DatePicker
          selected={endDate}
          onChange={changeEndDate}
          selectsEnd
          startDate={startDate}
          endDate={endDate}
          minDate={startDate}
          className="form-control form-control-md"
          placeholderText="Select end date"
        />
      </div>
    </Form.Group>
  );
};

export default DateRange;
